import React, { useState, useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  setOrderpinsDateRange,
  fetchOrderLocs,
  setOrderpins30DaysRange
} from "../../../../redux/geofence/actions";
import { Modal, Dropdown } from "semantic-ui-react";
import ModifiedCalendar from "../../../../common/components/ModifiedCalendar";
import "./style.less";
import moment from "moment";

const defaultOptions = [
  { key: 1, value: "LAST_30_DAYS", text: "Showing orders from last 30 days" },
  { key: 3, value: "CUSTOM_RANGE", text: "Choose custom date range" }
];

function OrdersDateRange() {
  const [selectedOption, changeOption] = useState(defaultOptions[0].value);
  const selectedDateRange = useSelector(
    ({ geofence }) => geofence.orderpinsFilter.dateRange,
    shallowEqual
  );
  const last30Days = useSelector(
    ({ geofence }) => geofence.orderpinsFilter.last30Days,
    shallowEqual
  );
  const dispatch = useDispatch();
  const [options, setOptions] = useState(defaultOptions);
  useEffect(() => {
    if (selectedDateRange) {
      setOptions([
        defaultOptions[0],
        {
          key: 2,
          value: "SELECTED_RANGE",
          text: `Showing order from ${selectedDateRange[0].format(
            "MMM Do YYYY"
          )}-${selectedDateRange[1].format("MMM Do YYYY")}`
        },
        defaultOptions[1]
      ]);
    }
    if (last30Days) {
      changeOption("LAST_30_DAYS");
      undoTo.current = "LAST_30_DAYS";
    } else {
      changeOption("SELECTED_RANGE");
      undoTo.current = "SELECTED_RANGE";
    }
  }, [selectedDateRange, last30Days, setOptions, changeOption]);

  const undoTo = useRef("LAST_30_DAYS");

  const onChangeHandler = useCallback(
    (e, { value }) => {
      undoTo.current = selectedOption;
      if (value === "LAST_30_DAYS") {
        dispatch(setOrderpins30DaysRange(true));
        changeOption(value);
        dispatch(fetchOrderLocs());
      } else if (value === "SELECTED_RANGE") {
        dispatch(setOrderpins30DaysRange(false));
        changeOption("SELECTED_RANGE");
        dispatch(fetchOrderLocs());
      } else {
        changeOption("CUSTOM_RANGE");
      }
    },
    [changeOption, dispatch, selectedOption]
  );
  const selectCustomDateRange = rangeArr => {
    dispatch(setOrderpinsDateRange(rangeArr));
    dispatch(fetchOrderLocs());
  };

  const handleCloseModal = useCallback(() => {
    if (selectedOption === "CUSTOM_RANGE") {
      changeOption(undoTo.current);
    }
  }, [selectedOption]);

  return (
    <div className="OrdersDateRange">
      <div>
        <Dropdown
          selection
          options={options}
          value={selectedOption}
          onChange={onChangeHandler}
        />
      </div>
      <Modal
        size="mini"
        open={selectedOption === "CUSTOM_RANGE"}
        closeOnEscape={true}
        closeOnDimmerClick={true}
        onClose={handleCloseModal}
      >
        <Modal.Content>
          <ModifiedCalendar
            selectRange={true}
            dateRange={
              last30Days
                ? [moment().subtract(30, "days"), moment()]
                : selectedDateRange
            }
            onChange={selectCustomDateRange}
          />
        </Modal.Content>
      </Modal>
    </div>
  );
}

OrdersDateRange.defaultProps = {};

OrdersDateRange.propTypes = {};

export default OrdersDateRange;
